module.exports = __webpack_public_path__ + "assets/a-shu5.a26eb18e.svg";